import { createSlice } from '@reduxjs/toolkit';

import { ManagerType } from '../../actions/types';
import { createManager, deleteManager, getManagers, getCurrentManager, updateManager } from '../../actions/clientManagersAction';

interface IManagersState {
  managers: ManagerType[];
  currentManager: ManagerType | null;
  isLoading: boolean;
  error: any;
}

const initialState: IManagersState = {
  managers: [],
  currentManager: null,
  isLoading: false,
  error: '',
};

export const managerSlice = createSlice({
  name: 'managers',
  initialState,
  reducers: {
    clearManagerError(state) {
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getManagers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getManagers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.managers = action.payload;
      state.error = '';
    });
    builder.addCase(getManagers.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getCurrentManager.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCurrentManager.fulfilled, (state, action) => {
      state.isLoading = false;
      state.currentManager = action.payload;
      state.error = '';
    });
    builder.addCase(getCurrentManager.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    builder.addCase(createManager.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createManager.fulfilled, (state, action) => {
      state.isLoading = false;
      state.managers.push(action.payload);
      state.error = '';
    });
    builder.addCase(createManager.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteManager.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteManager.fulfilled, (state, action) => {
      state.isLoading = false;
      state.managers = state.managers.filter((manager) => manager.id !== action.payload);
      state.error = '';
    });
    builder.addCase(deleteManager.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    builder.addCase(updateManager.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateManager.fulfilled, (state, action) => {
      state.isLoading = false;
      state.managers = state.managers.map((manager) =>
        manager.id === action.payload.id ? action.payload : manager
      );
      state.error = '';
    });
    builder.addCase(updateManager.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { clearManagerError } = managerSlice.actions;
export const managerReducer = managerSlice.reducer;
